import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import NavBar from "../../../Components/NavBar";
import cinstance from "../../../Service/randomcinstance";
import ListCard from "../../../Components/ListCard";
import LotteryCard from "../../../Components/mine-card/MineCard";
import SpinWheel from "../../../Components/SpinWheel/SpinWheel";
import "./AllLotteriesStyle.css";

const AllLotteries = (props) => {
  const [lotterylist1, setLotteryList1] = useState([]);
  const [lotterylist2, setLotteryList2] = useState([]);
  const [lotterylist3, setLotteryList3] = useState([]);
  const [lotterylist4, setLotteryList4] = useState([]);
  const [partnerList1, setPartnerList1] = useState([]);
  const [partnerList2, setPartnerList2] = useState([]);
  const [partnerList3, setPartnerList3] = useState([]);
  const [partnerList4, setPartnerList4] = useState([]);
  const [partnerLogoData, setPartnerLogoData] = useState([]);
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    let cancelled = false;

    const loadPartners = async (lotteries) => {
      const uniqueAddresses = [
        ...new Set(lotteries.map((lottery) => lottery.partnerAddress).filter(Boolean)),
      ];
      const results = await Promise.all(
        uniqueAddresses.map((address) =>
          cinstance.methods
            .partnerbyaddr(address)
            .call()
            .catch((err) => {
              console.log("partner", address, err);
              return null;
            })
        )
      );
      return results.filter(Boolean);
    };

    const loadLotteries = async () => {
      setLoading(true);

      // Optional logos: never block or break lottery loading
      if (apiUrl) {
        axios
          .get(`${apiUrl}/s3imageupload/getAllPartnerLogos`)
          .then((response) => {
            if (!cancelled) {
              setPartnerLogoData(response?.data?.result || []);
            }
          })
          .catch((err) => {
            console.log("partner logos skipped", err);
            if (!cancelled) setPartnerLogoData([]);
          });
      }

      try {
        const totalIds = Number(await cinstance.methods.lotteryId().call());
        const lotteryCalls = [];

        for (let i = 1; i < totalIds; i++) {
          lotteryCalls.push(
            cinstance.methods
              .lottery(i)
              .call()
              .catch((err) => {
                console.log("lottery", i, err);
                return null;
              })
          );
        }

        const lotteryResults = (await Promise.all(lotteryCalls)).filter(Boolean);
        const sortById = (a, b) => Number(b.lotteryId) - Number(a.lotteryId);

        const nextList1 = lotteryResults
          .filter(
            (lottery) =>
              Number(lottery.lotteryType) === 0 &&
              (lottery.status === "0" || lottery.status === "5")
          )
          .sort(sortById);

        const nextList2 = lotteryResults
          .filter(
            (lottery) =>
              Number(lottery.lotteryType) === 2 &&
              (lottery.status === "0" ||
                lottery.status === "3" ||
                lottery.status === "5")
          )
          .sort(sortById);

        const nextList3 = lotteryResults
          .filter(
            (lottery) =>
              Number(lottery.lotteryType) === 1 &&
              (lottery.status === "0" || lottery.status === "5") &&
              lottery.lotteryId
          )
          .sort(sortById);

        const nextList4 = lotteryResults
          .filter(
            (lottery) =>
              Number(lottery.lotteryType) !== 0 &&
              Number(lottery.lotteryType) !== 1 &&
              Number(lottery.lotteryType) !== 2 &&
              lottery.status !== "2" &&
              (lottery.status === "0" ||
                lottery.status === "3" ||
                lottery.status === "5")
          )
          .sort(sortById);

        const [nextPartners1, nextPartners2, nextPartners3, nextPartners4] =
          await Promise.all([
            loadPartners(nextList1),
            loadPartners(nextList2),
            loadPartners(nextList3),
            loadPartners(nextList4),
          ]);

        if (!cancelled) {
          setLotteryList1(nextList1);
          setLotteryList2(nextList2);
          setLotteryList3(nextList3);
          setLotteryList4(nextList4);
          setPartnerList1(nextPartners1);
          setPartnerList2(nextPartners2);
          setPartnerList3(nextPartners3);
          setPartnerList4(nextPartners4);
        }
      } catch (err) {
        console.log("AllLotteries load error", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadLotteries();

    return () => {
      cancelled = true;
    };
  }, [apiUrl]);

  const findPartnerByAddress = (address, partnerList) => {
    return (
      partnerList?.find((partner) => partner.partnerAddress === address) || {}
    );
  };

  return (
    <div fluid className="p-0 m-0 allLottery">
      <NavBar />
      <Container>
        <div className="mx-auto mt-3 ">
          <Row className="lottery-section">
            <Col>
              <h2
                className="section-title"
                style={{ fontWeight: "600", fontSize: "28px" }}
              >
                Explosive Lotteries
              </h2>
            </Col>
          </Row>
          {loading && (
            <Row>
              <Col>
                <h5 className="text-left mt-2">Loading lotteries...</h5>
              </Col>
            </Row>
          )}
          <Row className="mx-auto lottery-section2 text-center">
            <Col xs="12" className=" mb-2">
              <h3 className="text-left">
                <b>Autobet MRL</b>
              </h3>
            </Col>
            {!loading && lotterylist2.length === 0 && (
              <Col xs="12">
                <h5 className="text-left mt-2">No Active Lotteries !</h5>
              </Col>
            )}
            {lotterylist2.length > 0 &&
              lotterylist2.map((item, index) => {
                const partnerData = findPartnerByAddress(
                  item.partnerAddress,
                  partnerList2
                );
                return (
                  <Col lg={4} key={item.lotteryId || `mrl-${index}`}>
                    <ListCard
                      item={item}
                      history={props.history}
                      partner={partnerData}
                      partnerLogo={partnerLogoData}
                    />
                  </Col>
                );
              })}
          </Row>
          <Row className="mx-auto lottery-section2 text-center">
            <Col xs="12" className=" mb-2">
              <h3 className="text-left">
                <b>Autobet Revolver</b>
              </h3>
            </Col>
            {!loading && lotterylist1.length === 0 && (
              <Col xs="12">
                <h5 className="text-left mt-2">No Active Lotteries !</h5>
              </Col>
            )}
            {lotterylist1.length > 0 &&
              lotterylist1.map((item, index) => {
                const partnerData = findPartnerByAddress(
                  item.partnerAddress,
                  partnerList1
                );
                return (
                  <Col lg={4} key={item.lotteryId || `revolver-${index}`}>
                    <SpinWheel
                      lotteryData={item}
                      partner={partnerData}
                      partnerLogo={partnerLogoData}
                    />
                  </Col>
                );
              })}
          </Row>
          <Row className="mx-auto lottery-section2 text-center">
            <Col xs="12" className=" mb-2">
              <h3 className="text-left">
                <b>Autobet Mine</b>
              </h3>
            </Col>
            {!loading && lotterylist3.length === 0 && (
              <Col xs="12">
                <h5 className="text-left mt-2">No Active Lotteries !</h5>
              </Col>
            )}
            {lotterylist3.length > 0 &&
              lotterylist3.map((item, index) => {
                const partnerData = findPartnerByAddress(
                  item.partnerAddress,
                  partnerList3
                );
                return (
                  <Col lg={4} key={item.lotteryId || `mine-${index}`}>
                    <LotteryCard
                      history={props.history}
                      item={item}
                      partner={partnerData}
                      partnerLogo={partnerLogoData}
                    />
                  </Col>
                );
              })}
          </Row>
          <Row className="mx-auto lottery-section2 text-center">
            <Col xs="12" className="mb-2">
              <h3 className="text-left">
                <b>Autobet Missile</b>
              </h3>
            </Col>
            {!loading && lotterylist4.length === 0 && (
              <Col xs="12">
                <h5 className="text-left mt-2">No Active Lotteries !</h5>
              </Col>
            )}
            {lotterylist4.length > 0 &&
              lotterylist4.map((item, index) => {
                const partnerData = findPartnerByAddress(
                  item.partnerAddress,
                  partnerList4
                );
                return (
                  <Col lg={4} key={item.lotteryId || `missile-${index}`}>
                    <LotteryCard
                      history={props.history}
                      item={item}
                      lotteryType={"missile"}
                      partner={partnerData}
                      partnerLogo={partnerLogoData}
                    />
                  </Col>
                );
              })}
          </Row>
        </div>
      </Container>
    </div>
  );
};
export default AllLotteries;
